import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function usePostFactory() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      toast.success('Entrepôt créé avec succès.');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const postFactory = async (factoryData) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/factories', factoryData);
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        return response.data;
      } else {
        setIsSuccess(false);
        throw new Error();
      }
    } catch (error) {
      setError(error?.message || 'Une erreur est survenue.');
      setIsSuccess(false);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    postFactory,
  };
}

